import { FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';

export const contactInfo = [
  {
    icon: FaEnvelope,
    title: "Email",
    value: "hyarleysf@gmail.com",
    link: "mailto:hyarleysf@gmail.com",
    color: "text-purple-400"
  },
  {
    icon: FaLinkedin,
    title: "LinkedIn",
    value: "/in/hyarlei",
    link: "https://www.linkedin.com/in/hyarlei-silva/",
    color: "text-blue-400"
  },
  {
    icon: FaGithub,
    title: "GitHub",
    value: "/hyarlei",
    link: "https://github.com/hyarlei",
    color: "text-gray-400"
  }
];
